import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import { ENDPOINTS } from "../../../config/api";
import "bootstrap/dist/css/bootstrap.min.css";
import { useCallback } from "react";

const CreatePlan = () => {
  const { authFetch } = useContext(AuthContext);
  const navigate = useNavigate();

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [programas, setProgramas] = useState([]);
  const [planesActivos, setPlanesActivos] = useState([]);

  const [form, setForm] = useState({
    programa: "",
    fecha_inicio: "",
    fecha_fin: "",
    duracion_meses: ""
  });

  // =========================
  // LIMPIAR ALERTAS
  // =========================
  useEffect(() => {
    if (!error && !success) return;

    const timer = setTimeout(() => {
      setError("");
      setSuccess("");
    }, 5000);

    return () => clearTimeout(timer);
  }, [error, success]);

  // =========================
  // CARGAR PROGRAMAS
  // =========================
  useEffect(() => {
    const loadProgramas = async () => {
      try {
        const res = await authFetch(ENDPOINTS.get_programas);
        if (res.success) {
          setProgramas(res.data);
        }
      } catch {
        setError("Error cargando programas");
      }
    };

    loadProgramas();
  }, [authFetch]);

  // =========================
  // CARGAR PLANES ACTIVOS
  // =========================
  const loadPlanes = useCallback(async () => {
    try {
      const res = await authFetch(ENDPOINTS.get_plan_activo);

      if (res.success) {
        setPlanesActivos(res.data || []);
      }
    } catch {
      setError("Error cargando planes activos");
    }
  }, [authFetch]);
  useEffect(() => {
    loadPlanes();
  }, [loadPlanes]);


  // =========================
  // CALCULAR FECHA FIN
  // =========================
  useEffect(() => {
    if (form.fecha_inicio && form.duracion_meses > 0) {
      const inicio = new Date(form.fecha_inicio);
      inicio.setMonth(inicio.getMonth() + parseInt(form.duracion_meses));

      const fechaFinCalculada = inicio.toISOString().split("T")[0];

      setForm(prev => ({
        ...prev,
        fecha_fin: fechaFinCalculada
      }));
    }
  }, [form.fecha_inicio, form.duracion_meses]);

  // =========================
  // CREAR PLAN
  // =========================
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!form.programa) {
      setError("Debe seleccionar un programa");
      return;
    }

    if (!form.fecha_inicio) {
      setError("La fecha de inicio es obligatoria");
      return;
    }

    if (!form.duracion_meses || form.duracion_meses <= 0) {
      setError("La duración debe ser mayor a 0");
      return;
    }

    try {
      const res = await authFetch(ENDPOINTS.create_plan, {
        method: "POST",
        body: JSON.stringify({
          programa: form.programa,
          fecha_inicio: form.fecha_inicio,
          duracion_meses: form.duracion_meses
        })
      });

      if (!res.success) {
        setError(res.message);
        return;
      }

      setSuccess("Plan creado correctamente");

      setForm({
        programa: "",
        fecha_inicio: "",
        fecha_fin: "",
        duracion_meses: ""
      });

      loadPlanes(); // 🔥 Recargar tabla

    } catch {
      setError("Error en el servidor");
    }
  };

  return (
    <div className="container mt-4 p-4">

      {/* Título */}
      <div className="d-flex justify-content-between align-items-center m-3">
        <h3>Crear Plan de Acción</h3>

        <button
          type="button"
          className="btn btn-outline-pink"
          onClick={() => navigate("/session/plan_accion/plan_accion")}
        >
          <i className="bi bi-arrow-left me-1"></i>Volver
        </button>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      {/* FORMULARIO */}
      <form className="card p-4 shadow-sm mb-4" onSubmit={handleSubmit}>
        <div className="row g-3">

          <div className="col-md-3">
            <label>Programa</label>
            <select
              className="form-select"
              value={form.programa}
              onChange={(e) =>
                setForm({ ...form, programa: e.target.value })
              }
            >
              <option value=""hidden>Seleccionar...</option>
              {programas.map((prog) => (
                <option key={prog.id} value={prog.id}>
                  {prog.program_name || prog.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>Fecha inicio</label>
            <input
              type="date"
              className="form-control"
              value={form.fecha_inicio}
              onChange={(e) =>
                setForm({ ...form, fecha_inicio: e.target.value })
              }
            />
          </div>

          <div className="col-md-2">
            <label>Duración (meses)</label>
            <input
              type="number"
              min="1"
              className="form-control"
              value={form.duracion_meses}
              onChange={(e) =>
                setForm({ ...form, duracion_meses: e.target.value })
              }
            />
          </div>

          <div className="col-md-3">
            <label>Fecha fin</label>
            <input
              type="date"
              className="form-control"
              value={form.fecha_fin}
              readOnly
            />
          </div>

          <div className="col-md-1 d-flex align-items-end">
            <button className="btn btn-outline-pink w-100">
              Crear
            </button>
          </div>

        </div>
      </form>

      {/* TABLA DE PLANES ACTIVOS */}
      <div className="card p-4 shadow-sm">
        <h5>Hitos de pago vigentes</h5>

        <table className="table table-hover mt-3">
          <thead className="table-secondary">
            <tr>
              <th>Área</th>
              <th>Nombre del Plan</th>
              <th>Fecha Inicio</th>
              <th>Fecha Fin</th>
              <th>Duración</th>
              <th>Gestionar</th>
            </tr>
          </thead>
          <tbody>
            {planesActivos.length > 0 ? (
              planesActivos.map((plan) => (
                <tr key={plan.id}>
                  <td>{plan.area_nombre}</td>
                  <td>{plan.name}</td>
                  <td>{plan.date_start}</td>
                  <td>{plan.date_end}</td>
                  <td>{plan.duracion_meses} meses</td>
                  <td>
                    <button
                      className="btn btn-sm btn-outline-purple"
                      onClick={() => navigate(`/session/plan_accion/gestionar/${plan.id}`)}
                    >
                      Gestionar
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center">
                  No hay planes activos
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

    </div>
  );
};

export default CreatePlan;
